document.addEventListener('DOMContentLoaded', function() {
    const variantSelects = document.querySelector('variant-selects');
    const initialVariantId = document.querySelector('.product')?.dataset.variantId;
    initialVariantId && updateVariantMetafields(initialVariantId);
    
    function updateVariantMetafields(selectedVariant) {
        const metafieldElements = [
            { id: 'variant-description', attribute: 'variant' },
            { id: 'variant-ingredients', attribute: 'variant' },
            { id: 'variant-futterung_tabelle', attribute: 'variant'},
            { id: 'variant-futterung_tabelle_stuckzahl', attribute: 'variant'},
            { id: 'variant-zusatzstoffe', attribute: 'variant'},
            { id: 'variant-usps', attribute: 'variant' },
            { id: 'variant-analytische_bestandteile', attribute: 'variant' }
        ];
      console.log('Updating metafields for variant:', selectedVariant);

      const activeElements = metafieldElements.filter(item => document.getElementById(item.id));
            
      console.log('Active elements found:', activeElements.map(el => el.id));
    
        if (activeElements.length === 0) {
            console.log('No active metafield elements found');
            return;
        }
      
      // Check if stuckzahl values exist for this variant
      const stuckzahlElement = document.getElementById('variant-futterung_tabelle_stuckzahl');
      const stuckzahlValue = stuckzahlElement ? stuckzahlElement.dataset[`variant-${selectedVariant}`] : '';
      const hasStuckzahl = stuckzahlValue && stuckzahlValue.trim() !== '';
      
      // Update header colspan based on whether stuckzahl exists
      const feedingHeader = document.getElementById('feeding-header');
      if (feedingHeader) {
        feedingHeader.setAttribute('colspan', hasStuckzahl ? '2' : '1');
      }
      
      // Show/hide stuckzahl columns based on whether data exists
      const stuckzahlCells = document.querySelectorAll('.stuckzahl-cell');
      stuckzahlCells.forEach(cell => {
        cell.style.display = hasStuckzahl ? 'table-cell' : 'none';
      });
      
      activeElements.forEach(function (element) {
          const targetElement = document.getElementById(element.id);
          const metafieldValue = targetElement.dataset[`${element.attribute}-${selectedVariant}`];
        console.log('metafieldValue', metafieldValue);
          console.log(`Element: ${element.id}, Metafield value:`, metafieldValue);

          if (!targetElement || !metafieldValue) return;

          if (element.id === 'variant-futterung_tabelle') {
              // Special case: update each row's futtermenge with values from list
              let values;
              try {
                  values = JSON.parse(metafieldValue); // If it's JSON
              } catch (e) {
                  values = metafieldValue.split(',').map(v => v.trim()); // Fallback: comma-separated
              }

              const cells = document.querySelectorAll('.futtermenge-cell');
              console.log('Found cells:', cells.length, 'Values:', values);
              cells.forEach((cell, index) => {
                  cell.textContent = values[index] || '';
                  console.log(`Cell ${index}: ${values[index] || ''}`);
              });
          } else if (element.id === 'variant-futterung_tabelle_stuckzahl') {
              // Special case: update each row's stuckzahl with values from list
              let values;
              try {
                  values = JSON.parse(metafieldValue); // If it's JSON
              } catch (e) {
                  values = metafieldValue.split(',').map(v => v.trim()); // Fallback: comma-separated
              }

              const cells = document.querySelectorAll('.stuckzahl-cell');
              cells.forEach((cell, index) => {
                  cell.textContent = values[index] || '';
              });
          } else if (element.id === 'variant-analytische_bestandteile') {
              let values;
              try {
                  values = JSON.parse(metafieldValue);
              } catch (e) {
                  console.error('Invalid JSON in analytische_bestandteile:', e);
                  values = [];
              }

              const tableBody = document.getElementById('analytische-bestandteile-body');
              if (tableBody) {
                  tableBody.innerHTML = values.map(row => {
                      const cells = Object.values(row).map(value => `<td>${value}</td>`).join('');
                      return `<tr>${cells}</tr>`;
                  }).join('');
              }
          } else {
              if (element.id === 'variant-usps') {
                let values;
                try {
                    values = JSON.parse(metafieldValue);
                } catch (e) {
                    values = metafieldValue.split(',').map(v => v.trim());
                }
                const checkmarkIconUrl = targetElement.dataset.checkmarkIcon;
                targetElement.innerHTML = values.map(item => `
                    <div class="usps-item" style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
                        <img src="${checkmarkIconUrl}" alt="Checkmark" width="16" height="16" />
                        <span>${item}</span>
                    </div>
                `).join('');

            } else {
                targetElement.innerHTML = metafieldValue;
            }
          }
      });
    } 

    if (!variantSelects) {
        console.log('variant-selects element not found');
        return;
    }

    const variantScript = variantSelects.querySelector('script[type="application/json"]');
    const variants = variantScript ? JSON.parse(variantScript.textContent) : [];

    const radioButtons = variantSelects.querySelectorAll('input[type="radio"]');
    
    radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function() {
            if (this.checked) {
                const selectedVariant = variants.find(variant => 
                    variant.option1 === this.value
                );
                
                if (selectedVariant) {
                    updateVariantMetafields(selectedVariant.id);
                }
            }
        });
    });

    document.addEventListener('variant:change', function(event) {
        if (event.detail && event.detail.variant) {
            updateVariantMetafields(event.detail.variant.id);
        }
    });
    
    const selectedRadio = variantSelects.querySelector('input[type="radio"]:checked');

    if (selectedRadio) {
      const selectedVariant = variants.find(variant =>
        variant.option1 === selectedRadio.value
      );

      if (selectedVariant) {
        updateVariantMetafields(selectedVariant.id);
      }
    }
});